export default "__VITE_ASSET__B9_9zImp__"